import React, { useEffect, useState } from 'react'
import { get } from '../../../Common/api'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import { Flex } from 'antd'

dayjs.extend(weekday)

export default function ComputerBoxSchedules ({ box }) {
  const [days, setDays] = useState([])

  const weekDayOrder = [1, 2, 3, 4, 5, 6, 0]

  const getDays = async () => {
    await get({
      url: `public/boxes/${box.id}/box_schedules`,
      params: {},
      onSuccess: (res) => {
        setDays(res)
      }
    })
  }

  useEffect(() => {
    getDays()
  }, [])

  return (
    <Flex justify='space-around' gap='1em'>
      <div style={{ fontSize: '1.2em' }}>
        <div style={{ marginTop: '1.7em' }}>
          { weekDayOrder.map(day => {
            return <p key={`schedules-${day}`} style={{ margin: '0 0' }}>{`${dayjs().weekday(day - 1 % 7).format('dddd').substring(0, 3)} :`}</p>
          })}
        </div>
      </div>
      <div style={{ fontSize: '1.2em' }}>
        <div>
          <p style={{ margin: '0 0 0.5em 0' }}><b>Ouvertures</b></p>
          {weekDayOrder.map(day => {
            const currentDay = days.find(e => e.week_day === day)
            if (currentDay && currentDay.open) {
              const start = dayjs(currentDay.open.start).format('H/mm').replace('/', 'h')
              const end = dayjs(currentDay.open.end).format('H/mm').replace('/', 'h')
              return <p key={`open-${day}`} style={{ margin: '0 0' }}>{`${start}-${end}`}</p>
            } else {
              return <p key={`open-${day}`} style={{ margin: '0 0' }}>Fermée</p>
            }
          })}
        </div>
      </div>
      <div style={{ fontSize: '1.2em' }}>
        <div>
          <p style={{ margin: '0 0 0.5em 0' }}><b>Consultations</b></p>
          {weekDayOrder.map(day => {
            const currentDay = days.find(e => e.week_day === day)
            if (currentDay && currentDay.consulting) {
              const start = dayjs(currentDay.consulting.start).format('H:mm')
              const end = dayjs(currentDay.consulting.end).format('H:mm')
              return <p key={`consulting-${day}`} style={{ margin: '0 0' }}>{`${start.replace(':', 'h')}-${end.replace(':', 'h')}`}</p>
            } else {
              return <p key={`consulting-${day}`} style={{ margin: '0 0' }}>Fermées</p>
            }
          })}
        </div>
      </div>
    </Flex>
  )
}
